import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/home-1.png';
import _imports_1 from '@/assets/mine-1.png';
var _withScopeId = function (n) { return (_pushScopeId("data-v-4bc5c273"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "wrap" };
var _hoisted_2 = { class: "content" };
var _hoisted_3 = { class: "info-box" };
var _hoisted_4 = ["src"];
var _hoisted_5 = { class: "tip" };
var _hoisted_6 = { class: "menu" };
var _hoisted_7 = { href: "tel:010-67803629" };
var _hoisted_8 = /*#__PURE__*/ _createTextVNode("退出登录");
var _hoisted_9 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_0 }, null, -1); });
var _hoisted_10 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("img", { src: _imports_1 }, null, -1); });
import { ref } from "vue";
import { requestUserInfo, logout } from "@/api";
import { Dialog } from "vant";
import router from "../router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PersonalCenter',
    setup: function (__props) {
        var _this = this;
        var orderIcon = require("../assets/my-orders.png");
        var aboutUsIcon = require("../assets/about-us.png");
        var contactUsIcon = require("../assets/contact-us.png");
        var tel = ref("");
        var headImgUrl = ref("");
        var active = ref(1);
        var loading = ref(false);
        var handleLogout = function () {
            Dialog.confirm({
                message: "确认退出登录？",
            })
                .then(function () {
                loading.value = true;
                var userType = localStorage.getItem("userType");
                logout();
                localStorage.clear();
                localStorage.setItem("userType", userType);
                router.push("/login");
            })
                .catch(function () {
                // on cancel
            });
        };
        var getUserInfo = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestUserInfo()];
                    case 1:
                        res = _a.sent();
                        if (res.code === 200) {
                            tel.value = res.data.mobile;
                            headImgUrl.value = res.data.headImgUrl;
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        getUserInfo();
        var goOfficialWebsite = function () {
            location.href = "//liangjue.net/";
        };
        return function (_ctx, _cache) {
            var _component_van_icon = _resolveComponent("van-icon");
            var _component_van_nav_bar = _resolveComponent("van-nav-bar");
            var _component_van_cell = _resolveComponent("van-cell");
            var _component_van_button = _resolveComponent("van-button");
            var _component_van_tabbar_item = _resolveComponent("van-tabbar-item");
            var _component_van_tabbar = _resolveComponent("van-tabbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_van_nav_bar, {
                    title: "个人中心",
                    onClickLeft: _cache[0] || (_cache[0] = function ($event) { return (_unref(router).go(-1)); })
                }, {
                    left: _withCtx(function () { return [
                        _createVNode(_component_van_icon, {
                            color: "rgba(0,0,0,0.9)",
                            name: "arrow-left",
                            size: "24"
                        })
                    ]; }),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("img", {
                            src: headImgUrl.value || require('../assets/head.png'),
                            alt: ""
                        }, null, 8, _hoisted_4),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(tel.value), 1)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_van_cell, {
                            "is-link": "",
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (_unref(router).push('my-orders')); })
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_component_van_icon, {
                                    size: "0.4rem",
                                    name: _unref(orderIcon)
                                }, null, 8, ["name"])
                            ]; }),
                            title: _withCtx(function () { return [
                                _createElementVNode("span", {
                                    style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
                                }, "我的订单 ", 4)
                            ]; }),
                            _: 1
                        }),
                        _createVNode(_component_van_cell, {
                            "is-link": "",
                            onClick: goOfficialWebsite
                        }, {
                            icon: _withCtx(function () { return [
                                _createVNode(_component_van_icon, {
                                    size: "0.4rem",
                                    name: _unref(aboutUsIcon)
                                }, null, 8, ["name"])
                            ]; }),
                            title: _withCtx(function () { return [
                                _createElementVNode("span", {
                                    style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
                                }, "关于我们 ", 4)
                            ]; }),
                            _: 1
                        }),
                        _createElementVNode("a", _hoisted_7, [
                            _createVNode(_component_van_cell, { "is-link": "" }, {
                                icon: _withCtx(function () { return [
                                    _createVNode(_component_van_icon, {
                                        size: "0.4rem",
                                        name: _unref(contactUsIcon)
                                    }, null, 8, ["name"])
                                ]; }),
                                title: _withCtx(function () { return [
                                    _createElementVNode("span", {
                                        style: _normalizeStyle({ fontWeight: 500, marginLeft: '0.24rem' })
                                    }, " 联系我们", 4)
                                ]; }),
                                _: 1
                            })
                        ])
                    ]),
                    _createVNode(_component_van_button, {
                        class: "submit-btn",
                        square: "",
                        onClick: handleLogout
                    }, {
                        default: _withCtx(function () { return [
                            _hoisted_8
                        ]; }),
                        _: 1
                    }),
                    _createVNode(_component_van_tabbar, {
                        modelValue: active.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((active).value = $event); })
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(_component_van_tabbar_item, {
                                onClick: _cache[2] || (_cache[2] = function ($event) { return (_unref(router).push('/products')); })
                            }, {
                                icon: _withCtx(function () { return [
                                    _hoisted_9
                                ]; }),
                                _: 1
                            }),
                            _createVNode(_component_van_tabbar_item, null, {
                                icon: _withCtx(function () { return [
                                    _hoisted_10
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }, 8, ["modelValue"])
                ])
            ]));
        };
    }
});
